import {Times} from "@/assets/js/constant";

export default {
  data() {
    return {
      money: 0
    }
  },
  methods: {
    // 计算最后一期金额
    computedMoney(total, repayTotalStage, repayPerStageMoney) {
      return total - repayPerStageMoney * (repayTotalStage - 1)
    },
    repayType1(form) {
      this.money = form.repayTotalMoney
      return [{
        stageFinishTime: form.repayFinishTime,
        stageMoney: form.repayTotalMoney
      }]
    },
    // 全部分期
    repayType2(form) {
      this.money = form.repayTotalMoney
      if (form.repayTotalStage == '1') {
        return [{
          stageFinishTime: form.repayFirstFinishTime,
          stageMoney: form.repayPerStageMoney
        }]
      } else if (form.repayTotalStage == '2') {
        return [{
          stageFinishTime: form.repayFirstFinishTime,
          stageMoney: form.repayPerStageMoney
        }, {
          stageFinishTime: form.repayEndFinishTime,
          stageMoney: this.$utils.accSub(form.repayTotalMoney, form.repayPerStageMoney)
        }]
      } else {
        let arr = []
        arr.push({
          stageFinishTime: form.repayFirstFinishTime,
          stageMoney: form.repayPerStageMoney
        })
        this.createPlanStageList(form, arr, form.repayTotalStage - 2)
        arr.push({
          stageFinishTime: form.repayEndFinishTime,
          stageMoney: this.computedMoney(form.repayTotalMoney, form.repayTotalStage, form.repayPerStageMoney)
        })
        return arr
      }
    },
    // 先还+分期/
    repayType3(form) {
      this.money = form.repayStageTotalMoney + form.repayBeforeStageMoney
      let firstObj = {
        stageFinishTime: form.repayBeforeStageTime,
        stageMoney: form.repayBeforeStageMoney
      }
      if (form.repayTotalStage == '1') {
        return [
          firstObj, {
            stageFinishTime: form.repayFirstFinishTime,
            stageMoney: form.repayPerStageMoney
          }]

      } else if (form.repayTotalStage == '2') {
        return [
          firstObj,
          {
            stageFinishTime: form.repayFirstFinishTime,
            stageMoney: form.repayPerStageMoney
          }, {
            stageFinishTime: form.repayEndFinishTime,
            stageMoney: this.$utils.accSub(form.repayStageTotalMoney, form.repayPerStageMoney)
          }]
      } else {
        let arr = [firstObj]
        arr.push({
          stageFinishTime: form.repayFirstFinishTime,
          stageMoney: form.repayPerStageMoney
        })
        this.createPlanStageList(form, arr, form.repayTotalStage - 2)
        arr.push({
          stageFinishTime: form.repayEndFinishTime,
          stageMoney: this.computedMoney(form.repayStageTotalMoney, form.repayTotalStage, form.repayPerStageMoney)
        })
        return arr
      }
    },
    // 其他
    repayType4() {
      return [{
        stageFinishTime: '',
        stageMoney: ''
      }]
    },
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear(),
          m = date.getMonth() + 1,
          d = date.getDate(),
          h = date.getHours(),
          i = date.getMinutes(),
          s = date.getSeconds();
      if (m < 10) {
        m = '0' + m;
      }
      if (d < 10) {
        d = '0' + d;
      }
      if (h < 10) {
        h = '0' + h;
      }
      if (i < 10) {
        i = '0' + i;
      }
      if (s < 10) {
        s = '0' + s;
      }
      let t = y + '-' + m + '-' + d;
      return t;
    },
    createPlanStageList(form, arr, n) {
      // 每月还款日
      let repayPerTime = form.repayPerTime
      // 首次还款日
      let startTime = new Date(form.repayFirstFinishTime)
      for (let i = 0; i < n; i++) {
        // 当前时间的年月
        let YY = startTime.getFullYear()
        let MM = startTime.getMonth() + 1
        // 往后加一个月
        MM++;
        // 跨年 ，年份+1，月份变1
        if (MM == 13) {
          YY++;
          MM = 1
        }
        let day = new Date(YY, MM, 0).getDate()
        if (day < repayPerTime) {
          startTime = new Date(YY, MM - 1, day)
        } else {
          startTime = new Date(YY, MM - 1, repayPerTime)
        }
        arr.push({
          stageFinishTime: this.formatDate(startTime.getTime()),
          stageMoney: form.repayPerStageMoney
        })
      }
    },
    showMonthLastDay(date) {
      date = new Date(date)
      let MonthNextFirstDay = new Date(date.getFullYear(), date.getMonth() + 1);
      let MonthLastDay = new Date(MonthNextFirstDay - Times).getDate();
      return MonthLastDay;
    },
    getStartTime(form) {
      let startTime = new Date(form.repayFirstFinishTime)
      let startDay = startTime.getDate()
      let repayPerTime = form.repayPerTime
      return startTime.getTime() + (repayPerTime - startDay) * Times
    },
    /**
     * @description更新还款计划
     * @param planStageList
     * @param repayType
     * @param index
     */
    updateRepayType(planStageList, repayType, index) {
      if (repayType === '1' || repayType === '4') {
        return
      }
      let a = this.money
      let b = planStageList.length - (index + 1)
      let c = planStageList.reduce((prev, curr, idx) => {
        const value = idx > index ? 0 : Number(curr.stageMoney);
        if (!isNaN(value)) {
          return prev + value;
        } else {
          return prev;
        }
      }, 0)
      let d = (a-c) % b
      let e = ((a - c - d) / b)
      console.log(a , c, b, d);

      for (let i = index + 1; i < planStageList.length; i++) {
        if (i === planStageList.length - 1) {
          planStageList[i].stageMoney = e + d
        } else {
          planStageList[i].stageMoney = e
        }
      }
    }
  },
}
